import { MondayBoard } from "shared/integrations/mapper";
import { LiveIntegrationFilter, LiveIntegrationValue } from "./utils";
import { CSSProperties, useState } from "react";
import { useBoardTasks } from "frontend/hooks/use-board-integrations";
import style from "./liveIntegrationPicker.module.css";
import { LiveIntegrationBoardPicker } from "./liveIntegrationBoardPicker";
import { LiveIntegrationFiltersPicker } from "./liveIntegrationFiltersPicker";
import { MondayIntegrationType } from "shared/integrations/integration";
import { useFeatureFlag } from "frontend/hooks/use-feature-flag/use-feature-flag";
import { useIsCIMReorderEnabled } from "utils/url-utils";

export function LiveIntegrationPicker({
  integrationId,
  filters,
  documentId,
  onChange,
}: {
  integrationId?: string;
  filters: LiveIntegrationFilter[];
  documentId?: string;
  onChange: (newValue: LiveIntegrationValue) => void;
}) {
  const { mondayIntegration, addMondayIntegration, getBoardIntegrationConfig } = useBoardTasks(documentId);
  const [selectedBoard, setSelectedBoard] = useState<MondayBoard | null>(null);
  const [selectedFilters, setSelectedFilters] = useState<LiveIntegrationFilter[]>(filters);
  const [savingBoard, setSavingBoard] = useState(false);
  const isCIM = useIsCIMReorderEnabled();
  const newFloaters = useFeatureFlag("cim-new-floaters-style");
  const newStyle = isCIM && newFloaters;

  const selectedBoardId =
    integrationId && (selectedBoard?.id ?? getBoardIntegrationConfig(integrationId)?.config.boardId);

  async function onSelectBoard(board: MondayBoard | null) {
    if (!board) {
      return; // Selection cannot be cleared
    }

    if (!mondayIntegration) {
      return;
    }
    if (board.id === selectedBoardId) {
      setSelectedBoard(board);
      return;
    }
    setSavingBoard(true);
    // TODO: find another integration with the same boardId
    const integrationId = await addMondayIntegration(
      board.id,
      mondayIntegration.id,
      board.columns,
      MondayIntegrationType.live
    );
    setSavingBoard(false);
    setSelectedBoard(board);
    setSelectedFilters([]);
    onChange({ integrationId, filters: [] });
  }

  function changeFilters(filters: LiveIntegrationFilter[]) {
    setSelectedFilters(filters);
    onChange({ integrationId, filters });
  }
  return (
    <div
      className={style.container}
      style={newStyle ? ({ "--divider-color": "#5F5F60", "--text-color": "#A5B1BD" } as CSSProperties) : undefined}
    >
      <div className={style.header}>Create live view of:</div>
      <div className={style.boardContainer}>
        <LiveIntegrationBoardPicker
          mondayIntegrationId={mondayIntegration.id}
          selectedBoardId={selectedBoardId}
          onSelectBoard={onSelectBoard}
          styles={{
            // pickerActiveStyle: {background:"red"},
            // optionsPickerActiveStyle: {background:"red"},
            // searchContainer?: string;
            // optionListClassName?: string;
            // optionClassName: style.pickerOptionClassName,
            // optionTitleClassName?: string;
            // placeHolderClassName?: string;
            selectedOption: style.pickerSelectedOption,
            pickerParent: style.pickerParent,
            rounded: true,
          }}
        />
      </div>
      {savingBoard && (
        <div className={style.savingBoard}>
          Integrating your board...
          <span className={style.loader} />
        </div>
      )}
      {selectedBoard && !savingBoard && (
        <div className={style.filtersContainer}>
          <LiveIntegrationFiltersPicker
            filters={selectedFilters}
            columns={selectedBoard.columns}
            onSelectFilters={changeFilters}
            readonly={false}
          />
        </div>
      )}
    </div>
  );
}
